<template>
	<mm-select multiple return-array :options="options" v-bind="$attrs" @input="input" :value="selected"  />
</template>

<script>
const options = [
	"duplicate ip",
	"no paid user",
	"retention rate",
	"click spam",
	"proxy/vpn",
	"registration rate",
	"loyal_user_rate",
	"new_device_rate"
].map(v => {
	return { label: v, value: v };
});

export default {
	data() {
		return {
			options,
			selected: this.handleValue(this.value)
		};
	},
	watch: {
		value(v) {
			this.selected = this.handleValue(v);
		}
	},
	props: ["value"],
	methods: {
		input(v) {
			this.$emit("input", JSON.stringify(v));
		},
		handleValue(v){
			try {
				return JSON.parse(v);
			} catch (e) {
				return '';
			}
		}
	}
};
</script>